









































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Pagination from "./datePagination.vue";

import { dayNames } from "./utils";

@Component({
  components: {
    day: () => import("./day.vue"),
    pagination: Pagination
  }
})
export default class Month extends Vue {
  @Prop({ required: true })
  public weeks!: Date[][];

  @Prop({ required: true })
  public date!: Date;

  @Prop({ required: true })
  public selectedBeginDate!: Date;

  @Prop({ required: true })
  public selectedEndDate!: Date;

  @Prop({ required: true })
  public hoveredEndDate!: Date | null;

  public focusedDateData: any = {
    year: this.date.getFullYear(),
    month: this.date.getMonth()
  };

  public get visibleDayNames() {
    const visibleDayNames: string[] = [];
    let index = 0;
    while (visibleDayNames.length < dayNames.length) {
      const currentDayName: string = dayNames[index % dayNames.length];
      visibleDayNames.push(currentDayName);
      index++;
    }
    return visibleDayNames;
  }

  public onFocusedDateChaned({ year, month }) {
    this.focusedDateData = { year, month };
    this.$emit("month-update-date", new Date(year, month, 1));
    // this.$forceUpdate()
  }
}
